import { render, staticRenderFns } from "./Riassunto.vue?vue&type=template&id=60d81a9e&scoped=true&"
import script from "./Riassunto.vue?vue&type=script&lang=js&"
export * from "./Riassunto.vue?vue&type=script&lang=js&"
import style0 from "./Riassunto.vue?vue&type=style&index=0&id=60d81a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d81a9e",
  null
  
)

export default component.exports